import { createSelector } from "reselect";
import { first as _first } from "lodash";
import { MERCHANT_ID_REGEXP } from "../common/constants";
import { Merchant } from "../Merchant";
const merchant = (state: any, id: number) => {
  if (id)
    return _first(
      state.merchant.filter((merchant: Merchant) => merchant.id == id)
    );

  return null;
};

export const currentMerchantName = createSelector(
  merchant,
  (merchant: Merchant) => {
    let merchant_name = "";
    if (merchant != null) {
      merchant_name = merchant.name;
    }
    return merchant_name;
  }
);

export const currentMerchantId = createSelector(
  merchant,
  (merchant: Merchant) => {
    if (merchant != null) {
      return merchant.id.toString();
    }
    return;
  }
);



// WEBPACK FOOTER //
// ./client/modules/Merchant/selectors.ts